import { SkillCategory } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { useMemo, useState } from 'react'
import { useQuery } from 'react-query'
import { SkillMatrixResponse } from '../TrainingMatrixScreen'

export const GET_SKILL_MATRIX_URL = `/api/list/skill-need-templates/training-matrix/skill-matrix`
export const GET_CATEGORIES = `/api/list/skill-need-templates/categories`
export const CATEGORIES_QUERY_PARAM = 'categories'

export type UseSkillMatrixDataProps = {
  categories?: string[]
}

type SkillCategoryResponse = Pick<SkillCategory, 'id' | 'name'>[]

const useSkillMatrixData = ({
  categories: category,
}: UseSkillMatrixDataProps) => {
  const [categories, setCategories] = useState<
    { value: string; label: string }[]
  >([])

  const { isLoading: categoriesLoading } = useQuery<{
    result: SkillCategoryResponse
  }>('skillsAndNeedsCategories', () => getJSON({ url: GET_CATEGORIES }), {
    onSuccess: (data) => {
      const formattedCategories = data.result.map((category) => ({
        value: category.id || '',
        label: category.name || '',
      }))

      setCategories(formattedCategories)
    },
  })

  const categoriesQueryParams = useMemo(() => {
    if (!category || !category.length) {
      return ''
    }
    const query = new URLSearchParams({
      [CATEGORIES_QUERY_PARAM]: category?.join(','),
    })

    return `?${query.toString()}`
  }, [category])

  const { data: dataQuery, isLoading: dataIsLoading } = useQuery<{
    result: SkillMatrixResponse
  }>([`skillsAndNeeds-${categoriesQueryParams}`, categoriesQueryParams], () =>
    getJSON({ url: `${GET_SKILL_MATRIX_URL}${categoriesQueryParams}` })
  )

  return {
    isLoading: categoriesLoading || dataIsLoading,
    data: dataQuery?.result,
    categories,
  }
}

export default useSkillMatrixData
